import React, { useState, useEffect } from "react";
import { Button, Input, Col, Container, Row, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import BotList from "./BotList";
import BotGrid from "./BotGrid";
import { useDispatch } from "react-redux";
import { bot_list, group_list } from "../../slices/thunks";
import { useSelector } from "react-redux";
import Pagination from "../../Components/Common/Pagination_Cust";
import { Link } from "react-router-dom";
import config from "../../config";
import { change_page } from "../../slices/SideBarCust/reducer";
import SelectDBConnectionModal from "../../Components/Common/CustomModal/SelectDBConnectionModal";
import { reset_thread_list, reset_thread_reducer } from "../../slices/Thread/reducer";
import { reset_chat_history, reset_chat_history_whole } from "../../slices/Chat_Cust/reducer";
import CreateNewBot from "../../Components/Common/CustomModal/CreateNewBot";
import Create_New_Group_modal from "../../Components/Common/CustomModal/Create_New_Group_modal";
import { delete_chat_bot, get_distinct_bot_category } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../../slices/Success_Modal/reducer";
import { open_error_modal } from "../../slices/Error_Modal/reducer";
import { waitForDecision } from "../../utility/wait_for_confirmation";
import { close_confirm_modal, open_confirm_modal } from "../../slices/Confirm_Modal/reducer";
import { set_bread_crum } from "../../slices/header/reducer";
import { reset_Table_Data } from "../../slices/Table_Details/reducer";
import { reset_Bot_Details } from "../../slices/BotDetails/reduders";
import { reset_Share_Point_Details } from "../../slices/share_point/reducer";
import Mongo_DB_Query_modal from "../../Components/Common/CustomModal/Mongo_DB_Query_modal";
import Mongo_JsonViewer_Modal from "../../Components/Common/CustomModal/Mongo_JsonViewer_Modal";


const Bots = () => {
  document.title = "Dashboard | Bots";

  const dispatch = useDispatch();
  const group_details = useSelector((state)=>state.Group_List)
  const bot_list_data = useSelector((state) => state.Bot_List);
  const [bot_category_list, setbot_category_list] = useState([])

  const [activeView, setActiveView] = useState("grid");
  const [filter, setfilter] = useState({
  page: 1,
  per_page: config.general_config.PER_PAGE_CONTENT,
  sort_by: null,
  sort_order: null,
  search_group_id: null,
  search_bot_id: null,
  search_group_name: null,
  search_user_role: null,
  search_database_id: null,
  search_assets_id: null,
  search_type: null,
  search_max_record: null,
  search_bot_category: null,
  search_bot_title: null,
  search_bot_description: null,
  search_bot_sample_question: null,
  search_model: null,
  search_bot_allow_see_source: null,
  search_bot_instructions: null,
  search_status: null,
  search_last_updated_by: null,
  search_last_updated_date: null,
  sort_by_latest_use:1
  })

  const handleButtonClick = (view) => {
    setActiveView(view);
  };


  useEffect(() => {
    dispatch(change_page("Bot threads"))
    dispatch(bot_list());
    dispatch(group_list({ page:1 , per_page:1000 }))
    dispatch(reset_thread_list())
    dispatch(reset_chat_history())
    dispatch(reset_Table_Data())
    dispatch(reset_Bot_Details())
    dispatch(reset_chat_history_whole())
    dispatch(reset_Share_Point_Details())
  }, []);

  useEffect(() => {
    dispatch(reset_thread_list())
    dispatch(reset_chat_history())
    dispatch(reset_Table_Data())
    dispatch(reset_thread_reducer())
    dispatch(reset_chat_history_whole())
},[bot_list_data])


  useEffect(() => {
    get_distinct_bot_category().then((response) => {
      
           setbot_category_list(response.
            bot_categories)
         
    })
  }, [])



  const onChange_sort_by_group = (e) => {
    let filter_temp = filter
    if (e.target.value === " "){
     
      filter_temp.search_group_id = null;
 
      
    }
    else{
    
     
     filter_temp.search_group_id = e.target.value;

  
    }

    filter_temp.page=1
    setfilter(filter_temp)
 
      dispatch(bot_list(filter_temp))
  }

  const onChange_sort_by_last_use = (e) => {
    let filter_temp = filter
    if (e.target.value === " "){
     
      filter_temp.sort_by_latest_use = 0;
 
      
    }
    else{
    
     
     filter_temp.sort_by_latest_use = e.target.value;

  
    }

    filter_temp.page=1
    setfilter(filter_temp)
 
      dispatch(bot_list(filter_temp))
  }


  const onChange_sort_by_search_titles = (e) => {
    let filter_temp = filter
    if (e.target.value === " "){
     
      filter_temp.search_bot_title = null;
 
      
    }
    else{
    
     
     filter_temp.search_bot_title = e.target.value;

  
    }

    filter_temp.page=1
    setfilter(filter_temp)
 
      dispatch(bot_list(filter_temp))

  }


  const onPageChange = (page_number) => {
    let filter_temp = filter
    filter_temp.page=Number.parseInt(page_number)
    setfilter(filter_temp)
    dispatch(bot_list(filter_temp))
  }


  const onClick_Sort_By_Column =(column_name)=>{
    let filter_temp = filter



  
    if(filter_temp.sort_by === column_name){
       if(filter_temp.sort_order==='ASC'){

        filter_temp.sort_order = 'DESC'
       }
       else{
        filter_temp.sort_order = 'ASC'
       }
    }
    else{
         filter_temp.sort_order = 'ASC'
      filter_temp.sort_by = column_name;
    }
     

  
    

    filter_temp.page=1
    setfilter(filter_temp)
 
      dispatch(bot_list(filter_temp)) 
  }

  const onDelete_Bot = async (assistant_id)=>{
      
     dispatch(open_confirm_modal('Are you sure you want to delete this bot'))
      const descison = await waitForDecision();
       
      if(descison){

        delete_chat_bot(assistant_id).then((response)=>{
          dispatch(open_success_modal("Bot deleted  successfully"))
          dispatch(bot_list(filter)) 
      }).catch((error)=>{
           dispatch(open_error_modal("Failed to delete error modal"))
      })

      }


      dispatch(close_confirm_modal())
        
     

  }


  const [isActive, setIsActive] = useState(false);

  // Function to toggle the class
  const toggleClass = () => {
    setIsActive(!isActive);
  };


  const onChange_bot_Category_search = (e)=>{
    let filter_temp = filter
    filter_temp.search_bot_category=e.target.value
    setfilter(filter_temp)
    dispatch(bot_list(filter_temp))
  }

  useEffect(()=>{
    dispatch(set_bread_crum({ title:""  , pageTitle:""  }))

    return ()=>{
    dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
       
    }
  },[])

  return (
    <React.Fragment>
      <div className="page-content pt-10">  

        <Container fluid>
        {/* <BreadCrumb title="Bots" pageTitle="Dashboard" /> */}
           {/* <SelectDBConnectionModal /> */}
           <div style={{ display:'none' }} ><Create_New_Group_modal/></div>
        <Row>
            <Col xl={3}>
              <div className="wrap_bot_buttons d-flex justify-content-between align-items-center mb-3">
                  <div className="switch_view ">                
                    {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
                      <button
                      className={`btn ${activeView === "grid" ? "Active" : ""}`}
                      onClick={() => handleButtonClick("grid")}
                    >
                      {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
                      <i className="mdi mdi-apps"></i>
                    </button>
                    {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
                     <button
                      className={`btn ${activeView === "list" ? "Active" : ""}`}
                      onClick={() => handleButtonClick("list")}
                    >
                      <i className="mdi mdi-format-align-justify" />
                    </button>
                  </div>
                  <div className="sfs">
                  {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
                      <button onClick={toggleClass}>
                          <i className="mdi mdi-format-align-justify" />
                      </button>
                  </div>
              </div>
            </Col>
            <Col xl={9} className={isActive ? 'active-div' : 'dactive-div'}>
                <div className="filter_or_sort mb-3">
                    
                    <div className="input-group">
                        <Input onChange={onChange_sort_by_search_titles} type="text" className="form-control h-40" placeholder="Search Bot name" aria-label="Recipient's username with two button addons" />
                        <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20" /></button>
                    </div>
                      <div>
                        <select onChange={onChange_sort_by_group} className="form-select" aria-label="Default select example">
                            <option value={" "}>Filter by group</option>
                            {
                              group_details.groupList.map((ele, i)=>{
                                   return <option key={i} value={ele.Group_ID}>{ele.Group_Name}</option>
                              })
                            }
                           
                        </select>
                        </div>
                        <div>
                        <select onChange={onChange_bot_Category_search} className="form-select" aria-label="Default select example">
                            <option value={""} >Filter by category                             
                            </option>
                            {
                              bot_category_list.map((ele, i)=>{
                                   return <option key={i} value={ele}>{ele}</option>
                              })
                            }
                        </select>
                        </div>
                        <div>
                        <select onChange={onChange_sort_by_last_use} className="form-select" aria-label="Default select example">
                            <option value={1} >Sort by latest use                            
                            </option>
                            <option value={" "} >Sort by oldest use                            
                            </option>
                        </select>
                        </div>
                        <div className="d-grid gap-2">
                            {/* <Button color="primary" className="rounded-pill"> CREATE NEW BOT </Button> */}
                            <CreateNewBot className=""/>
                        </div>                        
                    
                </div>
            </Col>
          </Row>
          <Row>
            {/* <Mongo_DB_Query_modal/>
            <Mongo_JsonViewer_Modal/> */}
            {
             bot_list_data.loading
            //  true
            ?<div className="loader_wrapper"><Spinner /></div>:<Col xl={12}>
            {/* <Button color="primary" onClick={() => tog_center()}>Center Modal</Button> */}
            
              {activeView === "list" ? (
                <>
                 
                    <BotList onDelete_Bot={onDelete_Bot}  filter={filter}  onClick_Sort_By_Column={onClick_Sort_By_Column}  />
                  
                </>
              ) : (
                <>
            
                    <BotGrid onDelete_Bot={onDelete_Bot}  />
               
                </>
              )}
            </Col>}
          </Row>
          <Row className="mb-30">
            <Col>
            <Pagination onPageChange={onPageChange} total_pages={bot_list_data.total_pages} current_page={bot_list_data.currentPage} />
            </Col>
          </Row>
        </Container>
      </div>
      
    </React.Fragment>
  );
};

export default Bots;
